export default __webpack_public_path__ + "static/media/aircraft-tail-desc.ff381018.png";